<template>
  <div>
    <b-form-group
      label="Durum"
      label-for="status"
    >
      <b-form-checkbox
        id="status"
        v-model="itemData.status"
        value="1"
        switch
      >
        {{ itemData.status === '1'? 'Aktif' : 'Pasif' }}
      </b-form-checkbox>
    </b-form-group>
  </div>
</template>

<script>
import { BFormGroup, BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'StatusSelect',
  components: { BFormGroup, BFormCheckbox },
  computed: {
    itemData() {
      return this.$store.getters['serviceCategories/dataItem']
    },
  },
}
</script>
